(function() {
	'use strict';

	angular.module('returnLetterApp').controller('ReturnLetterController',
			ReturnLetterController);

	ReturnLetterController.$inject = [ '$scope', '$window', 'ReturnLetterService', '$log', 'AlertService','NgTableParams', '$state', 'RETURN_LETTER', 'CommonService', 'CONST_REPORT', 'FORMAT_DATE', 'ReportService', '$filter', '$uibModal', 'WF_TASK', '$base64'];

	function ReturnLetterController($scope, $window, ReturnLetterService, $log, AlertService, NgTableParams, $state, RETURN_LETTER, CommonService, CONST_REPORT, FORMAT_DATE, ReportService, $filter, $uibModal, WF_TASK, $base64) {
		var returnletterCtr = this;
		var self = $scope;
		self.loading = false;
		
		returnletterCtr.datePickerOpenStatus = {};
		returnletterCtr.datePickerOpenStatus.fromDate = false;
		returnletterCtr.datePickerOpenStatus.toDate = false;
		returnletterCtr.openCalendar = openCalendar;
		returnletterCtr.returnLetterCitys = {};
		returnletterCtr.getReturnLetter = getReturnLetter;
		returnletterCtr.printReport = printReport;
		returnletterCtr.openProcessLetter = openProcessLetter
		returnletterCtr.openReturnLetterViewDetail = openReturnLetterViewDetail;
		self.CONST_REPORT = CONST_REPORT;
		self.RETURN_LETTER = RETURN_LETTER;
		self.WF_TASK = WF_TASK;
		returnletterCtr.fromReturnDate = new Date();
		returnletterCtr.toReturnDate = new Date();
		returnletterCtr.returnLetterCitys = CommonService.query({masterurl:'get-return-letter-city'});
		returnletterCtr.reportParam = {'fromDate': returnletterCtr.fromReturnDate,
				 'toDate': returnletterCtr.toReturnDate,
				 'officeCode': returnletterCtr.officeCode,
				 'letterStatus' : returnletterCtr.letterStatus,
				 'policyNum' : returnletterCtr.policyNum,
				 'formatExport': RETURN_LETTER.FORMAT_EXPORT[0].code};
		
    	function getReturnLetter() {
    		returnletterCtr.tableParams.page(1);
    		returnletterCtr.tableParams.reload();
    	}
		
        function openCalendar (date) {
        	returnletterCtr.datePickerOpenStatus[date] = true;
        }
        returnletterCtr.dateOptions = {
				//maxDate : new Date()
		};
        returnletterCtr.openFromDate = function() {
        	returnletterCtr.popupFromDate.opened = true;
		};

		self.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		self.format = $scope.formats[2];
		self.altInputFormats = [ 'M!/d!/yyyy' ];
		returnletterCtr.popupFromDate = {
			opened : false
		};
		
		returnletterCtr.tableParams = new NgTableParams({
			page: 1,
			count: 20,
			sorting: {returnDate: 'desc'}
			},
			{
				total: 0,
				counts: [20, 40, 80],
				defaultSort: 'desc',
				getData: function(params) {
	    		var param = {};
	    		param['page'] = params.page();
	    		param['size'] = params.count();
	    		param['sort'] = params.sorting();
	    		param['uri'] = 'spec';
	    		if (returnletterCtr.fromReturnDate) {
	    			returnletterCtr.reportParam.fromDate = returnletterCtr.fromReturnDate;
	    			param['fromReturnDate'] = $filter('date')(returnletterCtr.fromReturnDate, FORMAT_DATE);
	    		}        		
	    		if (returnletterCtr.toReturnDate) {
	    			returnletterCtr.reportParam.toDate = returnletterCtr.toReturnDate;
	    			param['toReturnDate'] = $filter('date')(returnletterCtr.toReturnDate, FORMAT_DATE);
	    		}
	    		if (returnletterCtr.officeCode) {
	    			returnletterCtr.reportParam.officeCode = returnletterCtr.officeCode;
	    			param['officeCode'] = returnletterCtr.officeCode;
	    		}
	    		if (returnletterCtr.letterStatus) {
	    			returnletterCtr.reportParam.letterStatus = returnletterCtr.letterStatus;
	    			param['letterStatus'] = returnletterCtr.letterStatus;
	    		}
	    		if (returnletterCtr.policyNum) {
	    			returnletterCtr.reportParam.policyNum = returnletterCtr.policyNum;
	    			param['policyNum'] = returnletterCtr.policyNum;
	    		}
	    		return ReturnLetterService.query(param).$promise.then(function(result) {
	    			params.total(result.totalElements);
					return result.content;
				});            	
	        }
		});
		
		function printReport(){
	    	  /* returnletterCtr.reportParam = {'fromDate': returnletterCtr.fromReturnLetter,
						 'toDate': returnletterCtr.toReturnLetter,
						 'cityCode': returnletterCtr.cityCode,
						 'letterStatus' : returnletterCtr.letterStatus};*/
	    		self.loading = true;
	    		ReportService.download({uri:'report-return-letter-upload'}, returnletterCtr.reportParam,function(){
					$scope.loading = false;
				},
				function(){
					$scope.loading = false;
				});
	    	};
	    	
    	function openProcessLetter(item){
    		if (item.policyNum == undefined || item.policyNum == null) return false;
    		var page = returnletterCtr.tableParams.page();
    		var count = returnletterCtr.tableParams.count();
    		returnletterCtr.animationsEnabled = true;
    		ReturnLetterService.findInfoProcessReturnLetter({uri:'get-info-process-return-letter'},item, function(dataFind){
    			var modalInstance = 
    				//show dialog
    				$uibModal.open({
    					animation : returnletterCtr.animationsEnabled,
    					templateUrl : GLOBAL_URL+ 'partial?uri=ga/return-letter/return-letter-process-dialog',
    					controller : 'ReturnLetterProcessDialogController as processLetterDlgCtr',
    					size : 'lg',
    					resolve : {
    						returnLetter : function() {
    							return dataFind
    						}
    					}
    				});
    				modalInstance.result.then(function(result) {
    					returnletterCtr.tableParams = new NgTableParams({
    						page: page,
    						count: count,
    						sorting: {returnDate: 'desc'}
    						},
    						{
    							total: 0,
    							counts: [20, 40, 80],
    							defaultSort: 'desc',
    							getData: function(params) {
    				    		var param = {};
    				    		param['page'] = params.page();
    				    		param['size'] = params.count();
    				    		param['sort'] = params.sorting();
    				    		param['uri'] = 'spec';
    				    		if (returnletterCtr.fromReturnDate) {
    				    			returnletterCtr.reportParam.fromDate = returnletterCtr.fromReturnDate;
    				    			param['fromReturnDate'] = $filter('date')(returnletterCtr.fromReturnDate, FORMAT_DATE);
    				    		}        		
    				    		if (returnletterCtr.toReturnDate) {
    				    			returnletterCtr.reportParam.toDate = returnletterCtr.toReturnDate;
    				    			param['toReturnDate'] = $filter('date')(returnletterCtr.toReturnDate, FORMAT_DATE);
    				    		}
    				    		if (returnletterCtr.officeCode) {
    				    			returnletterCtr.reportParam.officeCode = returnletterCtr.officeCode;
    				    			param['officeCode'] = returnletterCtr.officeCode;
    				    		}
    				    		if (returnletterCtr.letterStatus) {
    				    			returnletterCtr.reportParam.letterStatus = returnletterCtr.letterStatus;
    				    			param['letterStatus'] = returnletterCtr.letterStatus;
    				    		}
    				    		if (returnletterCtr.policyNum) {
    				    			returnletterCtr.reportParam.policyNum = returnletterCtr.policyNum;
    				    			param['policyNum'] = returnletterCtr.policyNum;
    				    		}
    				    		return ReturnLetterService.query(param).$promise.then(function(result) {
    				    			params.total(result.totalElements);
    								return result.content;
    							});            	
    				        }
    					});
    				},
    				function(error){
    				});
    		}, function(errorFind) {
    			
    		});
    	};
    	
    	function openReturnLetterViewDetail(returnLetter) {
    		var uri = 'ga/return-letter/#/return-letter-view-detail/';
    		if(returnLetter.txnId != null && returnLetter.txnId != undefined && (returnLetter.processResultCode == '1' || returnLetter.processResultCode == '2')){
    			var num = $base64.encode(returnLetter.txnId);
    			uri = uri.concat(num);
    			$window.open(GLOBAL_URL + uri, '_blank')
    		} else {
    			var num = $base64.encode(returnLetter.returnLetterId);
    			uri = uri.concat(num);
    			$window.open(GLOBAL_URL + uri, '_blank')
    		}
    		
			
			
    	}
	}

})();
